import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { ProductConfigResponse } from 'model/shared/backend-api-response/product-config-response';
import { HttpService } from 'modules/shared/legacy-bookexpress/services/http.service';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  public configUrl: string = 'wbe-property-service/property';
  public languages = new BehaviorSubject<any>({});
  public cloudBackendDomain: string = environment.backendApiUrl;
  cicoDefaultLanguage: string = 'EN';
  constructor(public httpService: HttpService) {
    if (environment.proxy) {
      this.httpService.proxy = environment.proxy;
      this.httpService.apiUrl = environment.nodeApiUrl;
      this.cloudBackendDomain = environment.backendApiUrl;
    } else {
      let hostName = document.location.hostname;
      this.cloudBackendDomain = window.location.protocol + '//' + hostName;
    }
  }

  getCicoLanguages(lang: String, headers) {
    const serviceHeaders = headers['serviceHeaders'];
    const appName = headers['appName'];

    let url =
      this.cloudBackendDomain +
      '/' +
      this.configUrl +
      '/tenants/' +
      headers['tenantId'] +
      '/propertyId/' +
      headers['propertyId'] +
      '/uiMessages?appName=' +
      appName +
      '&langCode=' +
      lang;
    this.httpService.get(url, serviceHeaders).subscribe((languages: ProductConfigResponse) => {
      const isPropertyDataAvailable = Object.keys(languages?.propertyInitInfoMap).length !== 0;
      if (languages.Success && isPropertyDataAvailable) {
        sessionStorage.setItem(`langCode-selectedLanguage`, lang.toString());
        this.cicoLoading('none', '');
        this.languages.next(languages);
      } else {
        languages.ErrorMessage = languages?.ErrorMessage ? languages.ErrorMessage : 'Selected language is not configured';
        languages.Success = false;
        this.cicoLoading('none', '');

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const queryParamLangCode = urlParams.get('langCode');

        if (queryParamLangCode) {
          const url = new URL(window.location.href);
          let searchParams = new URLSearchParams(url.search);
          searchParams.set('langCode', this.cicoDefaultLanguage);
          const newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + searchParams.toString();
          window.history.replaceState({ path: newUrl }, '', newUrl);
        }
        sessionStorage.setItem(`langCode-selectedLanguage`, this.cicoDefaultLanguage);
      }
    });
  }

  cicoLoading(status, text) {
    if (status === 'block') {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    $('#preloaderCICO').css('display', status);
    $('#preloaderCICOText').html(text);
  }
}
